import React, { PropsWithChildren } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Instagram, Mail, MessageCircle } from 'lucide-react';
import StarterCta from '../StarterCta';
import { LeadFormProvider } from '../lead/LeadForm';

const WHATSAPP = 'https://wa.me/919868911575';
const INSTAGRAM = 'https://www.instagram.com/mystic_prana_by_madhulika?igsh=MTZwaWhtZGg2OWdvYw%3D%3D&utm_source=qr';
const EMAIL = 'mailto:mystikpranna@gmail.com';

/** Light, warm page frame shared by every page. */
const WarmShell: React.FC<PropsWithChildren> = ({ children }) => {
  const isHome = useLocation().pathname === '/';
  return (
  <LeadFormProvider>
  <div className="min-h-screen bg-cream text-plum font-lato selection:bg-lavender-200 overflow-x-hidden">
    <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-50 px-4 py-2 bg-lavender-700 text-white font-bold rounded">
      Skip to content
    </a>

    <header className="absolute top-0 inset-x-0 z-40">
      {/* No wordmark here: the hero eyebrow already carries the brand. */}
      <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-end">
        <nav className="flex items-center gap-6 text-sm" aria-label="Main">
          {!isHome && <Link to="/" className="text-plum-soft hover:text-lavender-700 transition-colors">Home</Link>}
          <Link to="/#how-it-works" className="hidden sm:inline text-plum-soft hover:text-lavender-700 transition-colors">How it works</Link>
          <Link to="/#about" className="hidden sm:inline text-plum-soft hover:text-lavender-700 transition-colors">About</Link>
          <StarterCta source="header" label="Begin" className="!px-5 !py-2 text-sm" />
        </nav>
      </div>
    </header>

    <main id="main-content">{children}</main>

    <footer className="border-t border-lavender-200">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-5 text-sm text-plum-soft">
        <p>© {new Date().getFullYear()} Mystic Prana. Heal with Madhulika.</p>
        <nav className="flex flex-wrap justify-center gap-6" aria-label="Footer">
          <Link to="/about-tarot" className="hover:text-lavender-700">About Tarot</Link>
          <Link to="/about-chakras" className="hover:text-lavender-700">About Chakras</Link>
          <Link to="/daily-card" className="hover:text-lavender-700">Daily Card</Link>
        </nav>
        <div className="flex items-center gap-4">
          <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" aria-label="Mystic Prana on Instagram" className="hover:text-lavender-700"><Instagram className="w-5 h-5" /></a>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" aria-label="Chat with Madhulika on WhatsApp" className="hover:text-lavender-700"><MessageCircle className="w-5 h-5" /></a>
          <a href={EMAIL} aria-label="Email Mystic Prana" className="hover:text-lavender-700"><Mail className="w-5 h-5" /></a>
        </div>
      </div>
    </footer>

    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Madhulika on WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-4 py-3 rounded-full bg-white text-lavender-700 border border-lavender-300 font-bold text-sm shadow-md hover:bg-lavender-50 transition-colors"
    >
      <MessageCircle className="w-5 h-5" aria-hidden="true" />
      <span className="hidden sm:inline">Chat with Madhulika</span>
    </a>
  </div>
  </LeadFormProvider>
  );
};

export default WarmShell;
